var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component",attrs:{"pageConfig":_vm.dynamicComponentConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }